import Info from "./Info";

export default Info;
export * from "./InfoRedux";
